import { render } from "./MctPlot.vue?vue&type=template&id=33b3fa84"
import script from "./MctPlot.vue?vue&type=script&lang=js"
export * from "./MctPlot.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__